function toggler() {
    var e = document.getElementById('btn');
    e.addEventListener('click', function () {
        if (this.className == 'on') this.classList.remove('on');
        else this.classList.add('on');
    });
}

export {
    toggler
}




// WEBPACK FOOTER //
// ./src/assets/toggler/toggler.js